import { UseForm, UseFormReturn } from '@/shared/application/hooks';
import { schema } from '@/auth/presentation/validators/RecoverySchema';
import { useRecovery } from './useRecovery';

type UseRecoveryReturn<T> = {
  loading: boolean;
  form: UseFormReturn<T>;
};

type UseRecoveryProps<T> = {
  useForm: UseForm<T>;
};

export const useRecoveryForm = ({ useForm }: UseRecoveryProps<any>): UseRecoveryReturn<any> => {
  const { recovery, loading } = useRecovery();

  const form = useForm({
    initialValues: {
      email: '',
    },
    onSubmit: (values) => {
      recovery(values);
    },
    validationSchema: schema,
  });

  return {
    form,
    loading,
  };
};
